export const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const snakeCaseToTitle = (text) => {
    return (text.charAt(0).toUpperCase() + text.slice(1)).replace(/_/g, ' ');
};

// Mirrors App\Rules\UkPostcode; the backend normalises casing/spacing before checking.
export const isValidPostcode = (postcode) => {
    const compact = (postcode || '').replace(/\s+/g, '').toUpperCase();
    return /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(compact);
};

export const POSTCODE_FORMAT_ERROR = 'Postcode must be a valid UK postcode';

const PRICE_CHANGE_REASONS = {
    incorrect_setup: 'Incorrect Setup',
    provider_price_change: 'Provider Price Change',
    missed_charge: 'Missed Charge',
    evidence_review: 'Evidence Review',
    other: 'Other',
};

export const promptPriceChangeReason = () => {
    return window.swal
        .fire({
            title: 'Why has the price changed?',
            text: 'This job is already completed. Please explain why the price is being changed.',
            html: `
                <select id="swal-price-change-reason" class="swal2-input" style="display:block;">
                    <option value="">Select a reason</option>
                    ${Object.entries(PRICE_CHANGE_REASONS)
                        .map(([value, label]) => `<option value="${value}">${label}</option>`)
                        .join('')}
                </select>
                <textarea
                    id="swal-price-change-notes"
                    class="swal2-textarea"
                    style="display:none;"
                    placeholder="Please explain why the price is being changed"
                ></textarea>
            `,
            showCancelButton: true,
            confirmButtonText: 'Save changes',
            cancelButtonText: 'Cancel',
            onOpen: () => {
                const select = document.getElementById('swal-price-change-reason');
                const notes = document.getElementById('swal-price-change-notes');
                select.addEventListener('change', () => {
                    notes.style.display = select.value === 'other' ? 'block' : 'none';
                });
            },
            preConfirm: () => {
                const select = document.getElementById('swal-price-change-reason');
                const notes = document.getElementById('swal-price-change-notes');

                if (!select.value) {
                    window.swal.showValidationMessage('Please select a reason');
                    return false;
                }

                if (select.value === 'other') {
                    if (!notes.value.trim()) {
                        window.swal.showValidationMessage('Please explain why the price changed');
                        return false;
                    }
                    return notes.value.trim();
                }

                return PRICE_CHANGE_REASONS[select.value];
            },
        })
        .then((result) => (result.value ? result.value.trim() : null));
};
